import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useHotkey from "hooks/useHotkey";
import NavIcon from "components/navigation/NavIcon";
import NavigationButton from "components/navigation/NavigationButton";
import QuickJumpModal from "./QuickJumpModal";
const QuickJumpModalContainer = () => {
  const { t } = useTranslation("common");
  const [showQuickJumpModal, setShowQuickJumpModal] = useState(false);
  const toggleModal = useCallback(() => setShowQuickJumpModal((cur) => !cur), [setShowQuickJumpModal]);
  useHotkey({
    actionKey: "show-quick-jump-modal",
    callback: () => setShowQuickJumpModal(true),
    scope: "general"
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(NavigationButton, { "aria-label": t("quick_jump.open"), id: "quickjump-search-nav", onClick: toggleModal }, /* @__PURE__ */ React.createElement(NavIcon, { type: "search", title: t("quick_jump.open") })), showQuickJumpModal && /* @__PURE__ */ React.createElement(QuickJumpModal, { onToggle: () => toggleModal() }));
};
export default QuickJumpModalContainer;
